import { c as _c } from "react/compiler-runtime";
import React, { ReactElement } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import styles from './carousel-dots.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly isCsr: boolean;
  readonly maxNavigation: number;
  readonly currentItem: number;
  readonly onClick: (navIndex: number) => void;
}
function CarouselDotsComponent(t0) {
  const $ = _c(6);
  const {
    isCsr,
    maxNavigation,
    currentItem,
    onClick
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("carousel");
  let t1;
  if ($[0] !== currentItem || $[1] !== formatMessage || $[2] !== isCsr || $[3] !== maxNavigation || $[4] !== onClick) {
    const navItems = isCsr ? Array.from({
      length: maxNavigation + 1
    }, (_, navIdx) => <button key={navIdx} title={formatMessage("pageButton", {
      page: navIdx + 1
    })} className={classNames(styles["carousel-dots__navigation-dot"], styles["carousel-dots__navigation-dot--button"], {
      [styles["carousel-dots__navigation-dot--selected"]]: currentItem === navIdx
    })} onClick={() => onClick(navIdx)} />) : Array.from({
      length: 3
    }, _temp);
    t1 = <div className={styles["carousel-dots"]}>{navItems}</div>;
    $[0] = currentItem;
    $[1] = formatMessage;
    $[2] = isCsr;
    $[3] = maxNavigation;
    $[4] = onClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function _temp(__0, dotsIdx) {
  return <span key={dotsIdx} className={classNames(styles["carousel-dots__navigation-dot"], styles["carousel-dots__navigation-dot--loading"])} />;
}
export default CarouselDotsComponent;